import { Pipe, PipeTransform } from '@angular/core';
import { CenterDepartment } from 'src/app/shared/models/center-department';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';

@Pipe({
	name: 'filterFormationByDepartment'
})
export class FilterFormationByDepartmentPipe implements PipeTransform {
	transform(
		missionRequests: MissionRequest[],
		centerDepartments: CenterDepartment[]
	): MissionRequest[] {
		if (
			missionRequests === null ||
			!missionRequests ||
			(Array.isArray(missionRequests) && missionRequests.length === 0) ||
			centerDepartments === null ||
			(Array.isArray(centerDepartments) && centerDepartments.length === 0)
		) {
			return missionRequests;
		}

		return missionRequests.filter((mr) =>
			centerDepartments.some((cd) =>
				cd.name.includes(mr.centerDepartment?.name)
			)
		);
	}
}
